export default __webpack_public_path__ + "static/media/Picture4.425dc867.jpg";